import { getPendingChangeOutlinedHighlightStyles } from '@sharedCR/common/form/shared/styles';

import { getConditionalObject } from 'utils/data';

import { customIconStyles, customIconWrapperStyles } from '../../../MainContent.styles';

export const wrapperStyles = {
  marginBottom: '24px',
};

export const getCardStyles = ({ isFieldChanged }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  padding: '16px',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderRadius: '4px',

  ...getConditionalObject(isFieldChanged, () => getPendingChangeOutlinedHighlightStyles(1)),
});

export const labelWrapperStyles = {
  display: 'flex',
  alignItems: 'center',
};

export const labelIconWrapperStyles = customIconWrapperStyles;

export const labelIconStyles = customIconStyles;

export const captionStyles = {
  marginBottom: '4px',
};
